export default "__VITE_ASSET__BErOqHH7__"